
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const UpdateAccount = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ACCOUNT_UPDATE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'ACCOUNT_UPDATE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'ACCOUNT_UPDATE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'ACCOUNT_UPDATE_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default UpdateAccount